import { render, staticRenderFns } from "./ProcessedTable.vue?vue&type=template&id=66f20aee"
import script from "./ProcessedTable.vue?vue&type=script&lang=js"
export * from "./ProcessedTable.vue?vue&type=script&lang=js"
import style0 from "./ProcessedTable.vue?vue&type=style&index=0&id=66f20aee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports